module.exports = __webpack_public_path__ + "1952c18cc260e696d53ffd66a762cf53.png";